import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const InformacionMenuMedicacion = ({ solicitud }) => {

  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Información Solicitud
      </Typography>
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Programa:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {solicitud?.tipoEmpadronamiento?.descripcion}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Fecha:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {new Date(solicitud?.fechaInicio).toLocaleString("es", optionsfecha)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}
              colSpan={4}
            >
              Observaciones:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {solicitud?.observaciones}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Medicamentos
      </Typography>

      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          {solicitud?.medicamentos.filter((medicamento) => medicamento.fechaBaja == null).map((item, index) => {
            return (
              <TableRow>
                <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                  {(index + 1) + ": " + item.medicamento.drogas + " - " + item.medicamento.presentacion + " - Cantidad p/presentación:" + item.cantidad}
                </TableCell>
              </TableRow>
            )
          })
          }

        </TableBody>
      </Table>
    </React.Fragment>
  );
};
